// Shared helper for the public survey-outcome pages.
//
// These pages are hit with ?userid=... in a fresh/incognito session whose
// language is whatever the visitor's browser detected — NOT the panelist's
// account default. The backend's getSurveyDisplayData now returns the
// panelist's resolved account language (users.language) as `language`. On
// mount, after the fetch resolves, each page calls this to load itself in the
// panelist's own language. The in-page LanguageToggle still works afterwards
// as a session-only override.
//
// Mirrors LanguageToggle's two-step contract:
//   languageChangeNavbar(lang) -> Redux + localStorage('userLanguagePreference')
//   i18n.changeLanguage(lang)  -> i18next page chrome
// Session-only: nothing here writes back to users.language.

import { Dispatch } from 'redux';
import i18n from '../../i18n';
import country from '../../config/countryConfig';
import { languageChangeNavbar } from '../Auth/auth.actions';

export const applyOutcomeLanguage = (dispatch: Dispatch, rawLanguage: any): void => {
    const supported: string[] =
        Array.isArray((country as any).supportedLanguages) && (country as any).supportedLanguages.length
            ? (country as any).supportedLanguages
            : ['en'];
    // `??` so an explicit '' falls through to the portal default rather than
    // being treated as a valid empty language.
    const fallback = supported[0] ?? 'en';
    const candidate = rawLanguage ?? '';
    const lang = supported.includes(candidate) ? candidate : fallback;
    dispatch(languageChangeNavbar(lang));
    i18n.changeLanguage(lang);
};
